import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PROPERTY_TYPES = [
    { value: '1', label: 'Einfamilienhaus' },
    { value: '2', label: 'Mehrfamilienhaus' },
    { value: '3', label: 'Gewerbeobjekt' },
    { value: '4', label: 'Mischobjekt' },
    { value: '5', label: 'Eigentumswohnung' },
    { value: '6', label: 'Grundstück' },
    { value: '7', label: 'Sonstige' },
    { value: '8', label: 'Sonstige2' }
];

const STATUS_OPTIONS = [
    { value: 'neu', label: 'Neu' },
    { value: 'in_bearbeitung', label: 'In Bearbeitung' },
    { value: 'aktiv', label: 'Aktiv' },
    { value: 'wartend', label: 'Wartend' },
    { value: 'abgeschlossen', label: 'Abgeschlossen' },
    { value: 'archiviert', label: 'Archiviert' }
];

const EXPOSE_STATUS_OPTIONS = [
    { value: 'draft', label: 'Entwurf' },
    { value: 'ready', label: 'Fertig' },
    { value: 'published', label: 'Veröffentlicht' },
    { value: 'archived', label: 'Archiviert' }
];

const PORTAL_STATUS_OPTIONS = [
    { value: 'not_published', label: 'Nicht veröffentlicht' },
    { value: 'prepared', label: 'Vorbereitet' },
    { value: 'published', label: 'Veröffentlicht' },
    { value: 'paused', label: 'Pausiert' },
    { value: 'archived', label: 'Archiviert' }
];

function Objects() {
    const [objects, setObjects] = useState([]);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const [formData, setFormData] = useState({
        object_number: '',
        reference_number: '',
        title: '',
        property_type_code: '',
        property_type_label: '',
        street: '',
        zip_code: '',
        city: '',
        status: '',
        expose_status: '',
        portal_status: '',
        website_visible: false,
        website_publish_as_offer: false,
        website_publish_as_reference: false,
        is_reference: false,
        invoice_created: false,
        invoice_paid: false
    });

    const loadObjects = async () => {
        try {
            const response = await axios.get('/api/objects');
            setObjects(Array.isArray(response.data) ? response.data : []);
        } catch (err) {
            setObjects([]);
            setError('Objekte konnten nicht geladen werden.');
        }
    };

    useEffect(() => {
        loadObjects();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const nextValue = type === 'checkbox' ? checked : value;

        if (name === 'property_type_code') {
            const selected = PROPERTY_TYPES.find((item) => item.value === value);
            setFormData((prev) => ({
                ...prev,
                property_type_code: value,
                property_type_label: selected ? selected.label : ''
            }));
            return;
        }

        setFormData((prev) => ({
            ...prev,
            [name]: nextValue
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        try {
            const response = await axios.post('/api/objects', formData);

            if (response.status === 200 || response.status === 201) {
                setMessage('Objekt erfolgreich erstellt.');
                await loadObjects();
            }
        } catch (err) {
            setError('Objekt konnte nicht gespeichert werden.');
        }
    };

    return (
        <div>
            <h1>Objekte</h1>

            {message && <p>{message}</p>}
            {error && <p className="error">{error}</p>}

            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="object_number"
                    placeholder="Objektnummer"
                    value={formData.object_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="reference_number"
                    placeholder="Referenznummer"
                    value={formData.reference_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="title"
                    placeholder="Objekttitel / Kurzbeschreibung"
                    value={formData.title}
                    onChange={handleChange}
                    required
                />

                <select
                    name="property_type_code"
                    value={formData.property_type_code}
                    onChange={handleChange}
                    required
                >
                    <option value="">Wählen Sie einen Objekttyp</option>
                    {PROPERTY_TYPES.map((item) => (
                        <option key={item.value} value={item.value}>
                            {item.label}
                        </option>
                    ))}
                </select>

                <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    required
                >
                    <option value="">Wählen Sie einen Status</option>
                    {STATUS_OPTIONS.map((item) => (
                        <option key={item.value} value={item.value}>
                            {item.label}
                        </option>
                    ))}
                </select>

                <select
                    name="expose_status"
                    value={formData.expose_status}
                    onChange={handleChange}
                    required
                >
                    <option value="">Wählen Sie einen Exposé-Status</option>
                    {EXPOSE_STATUS_OPTIONS.map((item) => (
                        <option key={item.value} value={item.value}>
                            {item.label}
                        </option>
                    ))}
                </select>

                <select
                    name="portal_status"
                    value={formData.portal_status}
                    onChange={handleChange}
                    required
                >
                    <option value="">Wählen Sie einen Portal-Status</option>
                    {PORTAL_STATUS_OPTIONS.map((item) => (
                        <option key={item.value} value={item.value}>
                            {item.label}
                        </option>
                    ))}
                </select>

                <input
                    type="text"
                    name="street"
                    placeholder="Straße"
                    value={formData.street}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="zip_code"
                    placeholder="PLZ"
                    value={formData.zip_code}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="city"
                    placeholder="Stadt"
                    value={formData.city}
                    onChange={handleChange}
                    required
                />

                <button type="submit">Objekt hinzufügen</button>
            </form>

            <table>
                <thead>
                    <tr>
                        <th>Objektnummer</th>
                        <th>Referenznummer</th>
                        <th>Titel</th>
                        <th>Stadt</th>
                    </tr>
                </thead>
                <tbody>
                    {objects.map((object) => (
                        <tr key={object.id || object.reference_number}>
                            <td>{object.object_number}</td>
                            <td>{object.reference_number}</td>
                            <td>{object.title}</td>
                            <td>{object.city}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Objects;
